/**
 * This grabs the CSRF token from the application's meta tag. You should likely never
 * have to use this if you only pass information to the server using the form tag.
 *
 * @returns {string}
 */
export function getCsrfToken() {
    // Issue the request
    // Grab the page's CSRF token so we can make a successful request
    // We're only adding the CSRF token if that attribute is set. This makes tests easier
    // and is a low stakes change since real calls will fail without the token
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
}

export function removeNulls(obj) {
    if (Array.isArray(obj)) {
        return obj
            .map(removeNulls)
            .filter((v) => v !== null && v !== undefined);
    } else if (obj && typeof obj === "object") {
        return Object.fromEntries(Object.entries(obj)
                                        .map(([k, v]) => [k, removeNulls(v)])
                                        .filter(([_, v]) => v !== null && v !== undefined));
    }

    return obj;
}

/**
 * Validate that the provided string is a valid UUID format
 * @param {string} uuid - The string to validate
 * @returns {boolean} - True if valid UUID format
 */
export function isValidUuid(uuid) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
}